import React from 'react';

const OrganizationDetailModal = ({ isOpen, onClose, user }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg w-4/5 max-w-2xl shadow-lg max-h-screen overflow-y-auto">
                {/* Modal Header */}
                <div className="flex justify-between items-center bg-gray-200 px-4 py-2 rounded-t-lg">
                    <h2 className="text-xl font-bold">Organization Details</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-600 hover:text-gray-900 text-lg font-bold"
                    >
                        &times;
                    </button>
                </div>

                {/* Modal Content */}
                <div className="p-6">
                    {/* Profile Section */}
                    <div className="flex mb-6 gap-8">
                        <img src={user.profile_picture} alt="Profile" className="w-20 h-20 rounded-full mr-4" />
                        <div>
                            <h3 className="text-2xl font-bold">
                                {user.first_name} {user.last_name}
                                {user.organization_title ? ` (${user.organization_title})` : ""}
                            </h3>
                            <p className="text-gray-600">{user.email}</p>
                            <div><strong>Paid Status:</strong> {user.paid_status === 2 || user.paid_status === 3 ? 'Yes' : 'No'}</div>
                            <div><strong>Status:</strong> {user.deleted ? "Active" : "Non-Active"}</div>
                        </div>
                    </div>

                    {/* Organization Details Section */}
                    <div className="mt-4">
                        <h4 className="text-lg font-semibold mb-2">Organization Details</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Organization Type:</strong> {user.organization_type ? user.organization_type : "NA"}</div>
                            <div><strong>Free Plan Used:</strong> {user.free_plan_used ? 'Yes' : 'No'}</div>
                            <div><strong>Featured Image:</strong> <a href={user.featured_image} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Download</a></div>
                            <div><strong>Website:</strong> <a href={user.apply_now_link} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">Visit</a></div>
                        </div>
                    </div>

                    {/* Social Section */}
                    <div className="mt-6">
                        <h4 className="text-lg font-semibold mb-2">Social Media Links</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Facebook:</strong> <a href={user.facebook} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{user.facebook}</a></div>
                            <div><strong>Instagram:</strong> <a href={user.instagram} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{user.instagram}</a></div>
                            <div><strong>LinkedIn:</strong> <a href={user.linkedin} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{user.linkedin}</a></div>
                            <div><strong>Twitter:</strong> <a href={user.twitter} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{user.twitter}</a></div>
                            <div><strong>YouTube:</strong> <a href={user.youtube} target="_blank" rel="noopener noreferrer" className="text-blue-500 hover:underline">{user.youtube}</a></div>
                        </div>
                    </div>

                    {/* Address Section */}
                    <div className="mt-6">
                        <h4 className="text-lg font-semibold mb-2">Address</h4>
                        <div className="grid grid-cols-2 gap-4">
                            <div><strong>Street Address:</strong> {user.street_address ? user.street_address : "NA"}</div>
                            <div><strong>City:</strong> {user.city ? user.city : "NA"}</div>
                            <div><strong>State:</strong> {user.state ? user.state : "NA"}</div>
                            <div><strong>Country:</strong> {user.country ? user.country : "NA"}</div>
                            <div><strong>Zip Code:</strong> {user.zip_code ? user.zip_code : "NA"}</div>
                        </div>
                    </div>

                    {/* Description Section */}
                    <div className="mt-6">
                        <div className="relative flex items-center pt-5">
                            <div className="flex-grow border-t border-gray-400"></div>
                            <span className="flex-shrink mx-4 text-gray-400">Description</span>
                            <div className="flex-grow border-t border-gray-400"></div>
                        </div>
                        <div className="mt-4">
                            <p>{user.description}</p>
                        </div>
                    </div>

                    {/* Close Button */}
                    <div className="mt-6 flex justify-end">
                        <button onClick={onClose} className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrganizationDetailModal;
